import SeatsPreview from '@/components/SeatsPreview/SeatsPreview';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface TableStatusProps {
  playerCount: number;
  maxPlayer: number;
  tableName: string;
  tableGame: string;
  padding?: boolean;
}
const TableStatus: FC<TableStatusProps> = ({ playerCount, maxPlayer, tableName, tableGame, padding = true }) => {
  return (
    <div className={twMerge('flex w-full justify-between pl-2', padding && 'px-5 py-3')}>
      <div className="flex gap-6">
        <SeatsPreview occupiedSeats={playerCount} maxPlayers={maxPlayer} />
        <div>
          <span className="block w-[160px] truncate whitespace-nowrap font-manrope text-sm font-bold text-ph-gray-white md:text-base">
            {tableName}
          </span>
          <p className="block w-[160px] truncate whitespace-nowrap font-manrope text-sm text-xs font-bold text-white text-opacity-50 md:text-base">
            {tableGame}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TableStatus;
